const buildVideoTokens = () => (state, silent) => {
  let label;
  let labelEnd;
  let labelStart;
  let pos;
  let res;
  let token;
  let href = '';
  const max = state.posMax;

  // 1. 检查当前字符是否为 '['
  if (state.src.charCodeAt(state.pos) !== 0x5b /* [ */) {
    return false;
  }

  // 2. 查找 ']'
  labelStart = state.pos + 1;
  labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);

  if (labelEnd < 0) {
    return false;
  }

  // 3. 提取 label 文本
  label = state.src.slice(labelStart, labelEnd);
  pos = labelEnd + 1;

  // 4. 检查 '(' 并提取 href
  if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */) {
    pos += 1;
    res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
    if (res.ok) {
      href = state.md.normalizeLink(res.str);
      if (state.md.validateLink(href)) {
        pos = res.pos;
      } else {
        href = '';
      }
    }
    pos += 1;
  }

  // 5. 只有 label 为 cw_video 时才匹配
  if (label !== 'cw_video' || !href) {
    return false;
  }

  // 6. 创建自定义 token
  if (!silent) {
    state.pos = labelStart;
    state.posMax = labelEnd;

    token = state.push('cw_video', 'video', 0);
    token.attrSet('src', href);
    token.attrSet('controls', 'controls');
    token.attrSet('style', 'max-width: 100%; border-radius: 8px;');
  }

  state.pos = pos;
  state.posMax = max;

  return true;
};

const renderVideo = () => (tokens, idx) => {
  const src = tokens[idx].attrGet('src') || '';
  return `<video src="${src}" controls style="max-width: 100%; border-radius: 8px;" class="cw-video"></video>`;
};

export default function videoPlugin(md) {
  md.renderer.rules.cw_video = renderVideo(md);
  md.inline.ruler.before('link', 'cw_video', buildVideoTokens(md));
}
